import {
  TypedStartListening,
  createListenerMiddleware,
  Unsubscribe,
} from "@reduxjs/toolkit";
import { store } from "..";
import { initAppListeners } from "./app/listeners";
import { initWizardListeners } from "./wizard/listeners";
import { combineReducers } from "redux";
import appReducer from "./app";
import wizardReducer from "./wizard";

export const listenerMiddlewareInstance = createListenerMiddleware({
  onError: () => console.error,
});

export function createRootReducer() {
  return combineReducers({
    app: appReducer,
    wizard: wizardReducer,
  });
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export const startAppListening =
  listenerMiddlewareInstance.startListening as AppStartListening;

export function initListeners(): Unsubscribe[] {
  return [
    initAppListeners(startAppListening),
    initWizardListeners(startAppListening)
  ];
}
